<app-header></app-header>
<app-sidebar
  ativo="Contatos"
></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Clientes"
      Pagina="Cliente"
    ></app-breadcrumb>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 text-right" style="margin-bottom: 10px;">
            <a (click)="abrirModalNovo()">
              <button class="btn btn-primary"><i class="fa fa-plus"></i> Cadastrar</button>
            </a>
          </div>
          <div class="col-md-12">
            <app-tabela titulo="Lista de clientes"
                        placeHolder="Buscar cliente"
                        [colunas]="colunas"
                        [linhas]="linhas"
                        [botaoEditar]="true"
                        linkBotaoEditar="cadastro/cliente/info-cliente"
            ></app-tabela>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<app-cadastro-novo-contato
  [showModal]="habilitarNovo"
  (fecharModalPai)="fecharModalNovo()"
></app-cadastro-novo-contato>
